import DOMPurify from 'dompurify';

// Targets that keep navigation inside an existing browsing context (case-insensitive per the
// HTML spec) — these never hand `window.opener` to a new tab, so no hardening needed.
const SAFE_TARGETS = ['_self', '_parent', '_top'];

DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName !== 'A') {
    return;
  }

  const target = node.getAttribute('target');
  if (!target || SAFE_TARGETS.includes(target.toLowerCase())) {
    return;
  }

  const relTokens = new Set((node.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
  relTokens.add('noopener');
  relTokens.add('noreferrer');
  node.setAttribute('rel', Array.from(relTokens).join(' '));
});

DOMPurify.setConfig({ ADD_ATTR: ['target'], USE_PROFILES: { html: true } });

const setSanitizedHtml = (el, value) => {
  el.innerHTML = DOMPurify.sanitize(value == null ? '' : String(value));
};

export const safeHtml = {
  bind(el, binding) {
    setSanitizedHtml(el, binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      setSanitizedHtml(el, binding.value);
    }
  },
  unbind(el) {
    el.innerHTML = '';
  },
};
